"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importStar(require("styled-components"));
const polished_1 = require("polished");
const getDisabledStyles = ({ theme, isDisabled }) => {
    if (isDisabled) {
        return (0, styled_components_1.css) `
      color: ${theme.fontColorActionDisabled};
      cursor: not-allowed;
    `;
    }
    return (0, styled_components_1.css) `
    cursor: pointer;
    color: ${theme.fontColorAction};
    &:hover {
      color: ${theme.fontColorActionHover};
      text-decoration: underline;
    }
  `;
};
const ActionText = styled_components_1.default.a `
  font-size: inherit;
  text-align: left;
  background: transparent;
  border: none;
  outline: none;
  padding: ${({ theme }) => theme.actionLinkPaddingHorizontal}
    ${({ theme }) => theme.actionLinkPaddingVertical};
  margin: 0 -${({ theme }) => theme.actionLinkPaddingVertical} 0 ${({ theme }) => theme.height};
  flex-shrink: 1;
  border-radius: 2px;
  text-decoration: none;
  ${({ shouldWrapText }) => !shouldWrapText && (0, polished_1.ellipsis)()}
  ${getDisabledStyles};

  &:focus-visible {
    text-decoration: underline;
    box-shadow: inset 0 0 0 ${({ theme }) => theme.borderSizeFocus}
      ${({ theme }) => theme.borderColorFocus};
  }
`;
exports.default = ActionText;
